let $object_search = $('.js-object-search');

$object_search.keyup(function (){
	
	let text = $object_search.val();
	let $rows = $('.js-object-rows');
	
	if(text.length > 2){
		
		let search = new RegExp(text, 'i');
		
		$rows.each(function () {
			
			let $row = $(this);
			let matches = 0;
			
			$row.find('.table-emulate__field-value').each(function (i,e) {
				if($(e).text().match(search) !== null) {
					matches++;
				}
			});
			
			if(matches > 0){
				$row.show();
			}else{
				$row.hide();
			}
		});
	}else{
		$rows.show();
	}
});
